import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "output"]

  // 追加一行空选项
  add() {
    const frag = this.templateTarget.content.cloneNode(true)
    this.listTarget.appendChild(frag)
    this.listTarget.lastElementChild?.querySelector("input")?.focus()
  }

  // 删除当前选项行
  remove(event) {
    event.currentTarget.closest("[data-option-row]").remove()
  }

  // 表单提交前，把各字段值序列化成 options JSON 写入 hidden field
  buildJson(event) {
    const type = this.element.dataset.questionType
    const opts = {}

    if (type === "single_choice" || type === "multi_choice") {
      const inputs = this.listTarget.querySelectorAll("[data-option-value]")
      opts.choices = Array.from(inputs).map(i => i.value.trim()).filter(Boolean)

    } else if (type === "rating") {
      opts.min = parseInt(this.element.querySelector("[data-rating-min]")?.value) || 1
      opts.max = parseInt(this.element.querySelector("[data-rating-max]")?.value) || 5
      opts.labels = {}
      this.element.querySelectorAll("[data-rating-label]").forEach(el => {
        if (el.value.trim()) opts.labels[el.dataset.ratingLabel] = el.value.trim()
      })

    } else if (type === "open_ended") {
      opts.goal = this.element.querySelector("[data-goal]")?.value.trim() || ""
      opts.max_followups = parseInt(this.element.querySelector("[data-max-followups]")?.value) || 2
      // 保留既有 trigger（v1 不支持编辑 trigger）
      const triggerEl = document.getElementById("existing_trigger_data")
      if (triggerEl?.value) {
        try { opts.trigger = JSON.parse(triggerEl.value) } catch (e) {}
      }
    }

    this.outputTarget.value = JSON.stringify(opts)
  }
}
